// MUST be first — installs the ResizeObserver-loop guard before React, any library,
// or the dev-server client loads. (Dev-only; no effect in production.)
import './lib/suppressResizeObserverError';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './lib/analytics';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}
